import { render, staticRenderFns } from "./GRITable2021Micro.vue?vue&type=template&id=2249da9d&scoped=true"
import script from "./GRITable2021Micro.vue?vue&type=script&lang=js"
export * from "./GRITable2021Micro.vue?vue&type=script&lang=js"
import style0 from "./GRITable2021Micro.vue?vue&type=style&index=0&id=2249da9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2249da9d",
  null
  
)

export default component.exports